<section class="card share-card">
        <div class="share-copy">
          <h2>出欠依頼URL・QRコード</h2>
          <p>事前回答・当日出席で同じURLとQRを使用します。</p>
          <input aria-label="出欠依頼URL" readonly [value]="participantUrl" (click)="$any($event.target).select()">
          <div class="share-actions">
            <button mat-raised-button (click)="copyUrl()">URLをコピー</button>
            <button mat-raised-button [disabled]="!qrDataUrl" (click)="copyQr()">QR画像をコピー</button>
            <button mat-raised-button [disabled]="!qrDataUrl" (click)="saveQr()">PNGを保存</button>
            <button mat-raised-button [disabled]="!qrDataUrl" (click)="openPoster()">掲示用を開く</button>
          </div>
        </div>
        @if (qrDataUrl) {
          <img class="qr-preview" [src]="qrDataUrl" width="112" height="112" alt="出欠依頼URLのQRコード">
        }
        @if (qrError) { <p class="share-error" role="alert">{{ qrError }}</p> }
        <p class="share-status" role="status">{{ shareMessage }}</p>
      </section>
